<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="passwordForm">
		<div class="grid">
			<!--<div class="col-12 flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl">
				<p-tag icon="pi cm-alert" [value]="('PASSWORD_WARNING_INFO' | translate)" severity="warning"></p-tag>
			</div>-->
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap border-bottom-1 border-100"
					[ngClass]="dynamicInputTextFormat('borderRow')">
					<div class="flex align-items-center justify-content-center gap-2"
						[ngClass]="dynamicInputTextFormat('label')">{{ 'ENABLED_PASSWORD' | translate }}
						<!--<p-button
							pTooltip="{{'PINCODE_INFO_TOOLTIP' | translate }}" tooltipPosition="bottom" icon="pi cm-info"
							size="large" [rounded]="false" [text]="true"
							severity="primary">
						</p-button>-->
					</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="dynamicInputTextFormat('borderInput')">
						<p-inputSwitch inputId="enabledPassword-switch" formControlName="enabledPassword"
							(onChange)="enablePassSwitch()"></p-inputSwitch>
					</div>
				</div>
			</div>
			<div *ngIf="passwordEnabled" class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.PasswordOld, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordOld, 'label')">{{ 'OLD_PASSWORD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordOld, 'borderInput')">
						<p-password inputId="settings-password-old" formControlName="PasswordOld" [toggleMask]="true"
							[feedback]="false" autocomplete="current-password" [maxLength]="lengthPassword"
							placeholder="{{ 'OLD_PASSWORD' | translate }}" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" [inputStyleClass]="dynamicInputTextWidth()">
						</p-password>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.PasswordOld) && !this.f.PasswordOld.errors?.incorrect"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate
					}}. {{ 'AUTOMATION_PASSWORD_NUMBER' | translate }}. {{ 'INSERT_ATLEAST_3CHARS' | translate }}.</small>
				<small *ngIf="showErrorRequiredMessage(this.f.PasswordOld) && this.f.PasswordOld.errors?.incorrect"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'INVALID_PASSWORD' |
					translate }}.</small>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()"
				*ngIf="(!passwordEnabled && f.enabledPassword.value) || (passwordEnabled && f.enabledPassword.value)">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.PasswordNew, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordNew, 'label')">{{ 'NEW_PASSWORD' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.PasswordNew, 'borderInput')">
						<p-password inputId="settings-password-new" formControlName="PasswordNew" [toggleMask]="true"
							[feedback]="false" autocomplete="new-password" [maxLength]="lengthPassword"
							placeholder="{{ 'NEW_PASSWORD' | translate }}" [ngClass]="dynamicInputTextWidth()"
							[styleClass]="dynamicInputTextWidth()" [inputStyleClass]="dynamicInputTextWidth()">
						</p-password>
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.PasswordNew) && !newPassInvalid"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate
					}}. {{ 'AUTOMATION_PASSWORD_NUMBER' | translate }}. {{ 'INSERT_ATLEAST_3CHARS' | translate }}.</small>
				<small *ngIf="showErrorRequiredMessage(this.f.PasswordNew) && newPassInvalid"
					class="flex align-items-center text-50 pt-1" [ngClass]="justifyContentStyle()">{{ 'NEW_PASSWORD_INVALID'
					| translate }}.</small>
			</div>
		</div>

		<div class="grid mt-8 mb-1 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}" [disabled]="disableConfirm"
				class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CLOSE' | translate }}"
				class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>